import api from '@/modules/api.service';
import type { RelatorioAtividadeDto } from '../relatorios-atividades.types';
import { mapRelatorioListItem } from './relatorios-atividades.mappers';

export async function buscarRelatoriosDoDefensorUseCase(
  defensorId: number,
  defensoriaId?: number,
  mes?: string,
  ano?: number,
  tipo?: string,
  status?: string,
): Promise<RelatorioAtividadeDto[]> {
  try {
    const params: any = {
      defensorId,
    };

    if (defensoriaId) params.defensoriaId = defensoriaId;
    if (mes) params.mes = mes;
    if (ano) params.ano = ano;
    if (tipo) params.tipo = tipo;
    if (status) params.status = status;

    const response = await api.get(`/relatorios/atividades`, { params });
    const relatorios = response.data || [];

    return relatorios.map((r: any) => mapRelatorioListItem(r));
  } catch (error) {
    console.error('Erro ao buscar relatórios:', error);
    return [];
  }
}
